import './style.scss'
import { Button, message, Table } from 'antd'
import dayjs from 'dayjs'
import { FC, memo, useEffect, useRef, useState } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import * as Api from '@/api/account'
import * as HomeApi from '@/api/home'
import Douban from '@/assets/plat-douban.png'
import Douyin from '@/assets/plat-douyin.png'
import Kuaishou from '@/assets/plat-kuaishou.png'
import Shipinhao from '@/assets/plat-shipinhao.png'
import Weibo from '@/assets/plat-weibo.webp'
import Xiaohongshu from '@/assets/plat-xiaohongshu.png'
import Zhihu from '@/assets/plat-zhihu.png'
import { IconScore } from '@/assets/svg/icon-score'
import TaskAchieve from '@/assets/task-achieve.jpg'
import TaskDay from '@/assets/task-day.jpg'
import TaskNewuser from '@/assets/task-newuser.jpg'
import TaskVip from '@/assets/task-vip.jpg'
import CheckLogin from '@/components/CheckLogin'
import { UserStore } from '@/global-states'
import { eventTracking, urlSource } from '@/libs/util'

const Invite: FC = () => {
  const { t: translate } = useTranslation(['invite', 'system'])
  const navigate = useNavigate()

  const [profile, setProfile] = useState<any>()
  const [logs, setLogs] = useState<any>([])
  const logsRef = useRef<any>()
  const [tabIndex, setTabIndex] = useState(0)
  const [tasks, setTasks] = useState<any[]>([])

  useEffect(() => {
    eventTracking('MyInvitePage')

    const id = location.href?.split('#')[1]
    if (id) {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
    }
  }, [])

  useEffect(() => {
    initData()
  }, [tabIndex])

  const initData = () => {
    if (tabIndex === 0) {
      getProfile()
      getCreditsLogs()
    } else {
      if (tabIndex === 1) {
        eventTracking('DailyTaskTabClick')
      }
      if (tabIndex === 2) {
        eventTracking('NewuserTaskTabClick')
      }
      if (tabIndex === 3) {
        eventTracking('AchieveTaskTabClick')
      }
      getBonusTasks()
    }
  }

  const getBonusTasks = async () => {
    const res = await HomeApi.getBonusTasks({
      category: tabIndex
    })
    setTasks(res?.list || [])
  }

  const getProfile = async () => {
    const res = await Api.getProfile()
    setProfile(res)
  }

  const getCreditsLogs = async () => {
    const res = await Api.getCreditsLogs()
    setLogs(res.list || [])
  }

  const submit = () => {
    window.open('https://lingverse.feishu.cn/share/base/form/shrcn2DoUSTZLMcCLGNEYqUiSph')
  }

  const toComplete = (t: any) => {
    if (t.status === 1) {
      navigate(t.target_route || '/')
    } else {
      receiveAward(t.type)
    }
  }

  const receiveAward = async (type: number) => {
    await HomeApi.updateTask({
      type
    })
    getBonusTasks()
    UserStore.updateUserPackage()
    if (type === 1) {
      message.success(translate('invite.sign_success'))
    } else {
      message.success(translate('invite.receive_success'))
    }
  }

  return (
    <div className="page-common page-invite">
      <div className="common-header">{translate('invite.free_points')}</div>
      <div className="common-wrapper">
        <div className="page-invite-wrapper">
          <div className="page-invite-box">
            <div className="box-header">
              <div className="img-box">
                <img style={{ display: tabIndex === 0 ? 'block' : 'none' }} className="img" src={TaskNewuser} />
                <img style={{ display: tabIndex === 1 ? 'block' : 'none' }} className="img" src={TaskDay} />
                <img style={{ display: tabIndex === 2 ? 'block' : 'none' }} className="img" src={TaskVip} />
                <img style={{ display: tabIndex === 3 ? 'block' : 'none' }} className="img" src={TaskAchieve} />

                <div className="tabs">
                  <div className={`tab-item ${tabIndex === 0 ? 'actived' : ''}`} onClick={() => setTabIndex(0)}>
                    <span>{translate('invite.invite_gifts')}</span>
                  </div>
                  <div className={`tab-item ${tabIndex === 1 ? 'actived' : ''}`} onClick={() => setTabIndex(1)}>
                    <span>{translate('invite.daily_tasks')}</span>
                  </div>
                  <div className={`tab-item ${tabIndex === 2 ? 'actived' : ''}`} onClick={() => setTabIndex(2)}>
                    <span>{translate('invite.newbie_tasks')}</span>
                  </div>

                  {/* <div className={`tab-item ${tabIndex === 3 ? 'actived' : ''}`} onClick={() => setTabIndex(3)}>
                    <span>{translate('invite.achievement_tasks')}</span>
                  </div> */}
                </div>

                {tabIndex === 0 && <div className="box-header-title">{translate('invite.invite_header_title')}</div>}
                {tabIndex === 1 && (
                  <div className="box-header-title">{translate('invite.daily_tasks_header_title')}</div>
                )}
                {tabIndex === 2 && (
                  <div className="box-header-title">{translate('invite.newbie_tasks_header_title')}</div>
                )}
                {tabIndex === 3 && (
                  <div className="box-header-title">{translate('invite.achievement_tasks_header_title')}</div>
                )}
              </div>
            </div>
            <div className="box-content">
              {tabIndex === 0 ? (
                <div className="page-invite-main">
                  <div className="invite-main" id="recharge">
                    <div className="content">
                      <div className="content-header">
                        <div className="title">{translate('invite.invite_order_title')}</div>
                        <div className="desc">
                          <span className="gradient">{translate('invite.invite_order_subtitle')}</span>
                        </div>
                      </div>
                      <div className="content-main">
                        <div className="left">
                          <div className="content-title">{translate('invite.invite_order_description')}</div>
                          <div className="content-desc l28">
                            {translate('invite.monthly_member_reward')}
                            <label className="num">5000</label>
                            {translate('invite.reward_r')}
                          </div>
                          <div className="content-desc l28">
                            {translate('invite.yearly_member_reward')}
                            <label className="num">60000</label>
                            {translate('invite.reward_r')}
                          </div>
                          <div className="form-item">
                            <div className="form-content">
                              <div className="link">
                                <div className="h">{`${location.origin}/i/${profile?.affiliate_code || ''}`}</div>
                              </div>
                              <CopyToClipboard
                                text={`${location.origin}/i/${profile?.affiliate_code || ''}`}
                                onCopy={() => {
                                  eventTracking('CopyInviteAddress')
                                  message.success(translate('invite.link_copied'))
                                }}
                              >
                                <Button type="primary">{translate('invite.copy_invite_link')}</Button>
                              </CopyToClipboard>
                            </div>
                          </div>
                          <div className="form-item">
                            <div className="form-content">
                              <div className="link">
                                <div className="h">{profile?.affiliate_code || ''}</div>
                              </div>
                              <CopyToClipboard
                                text={profile?.affiliate_code || ''}
                                onCopy={() => {
                                  eventTracking('CopyInviteCode')
                                  message.success(translate('invite.code_copied'))
                                }}
                              >
                                <Button type="primary">{translate('invite.copy_invite_code')}</Button>
                              </CopyToClipboard>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="invite-main" id="regeister">
                    <div className="content">
                      <div className="content-header">
                        <div className="title">{translate('invite.invite_register_title')}</div>
                        <div className="desc desc-green">
                          <span className="gradient-green">{translate('invite.invite_register_subtitle')}</span>
                        </div>
                      </div>
                      <div className="content-main">
                        <div className="left">
                          <div className="content-title">{translate('invite.invite_register_description')}</div>
                          <div className="content-desc">
                            {translate('invite.register_reward')}
                            <label className="num">100</label>
                            {translate('invite.reward_r')}
                          </div>

                          <div className="content-title mt36">{translate('invite.how_to_get_link')}</div>
                          <div className="content-desc">{translate('invite.get_link_instructions')}</div>
                        </div>
                        <div className="right">
                          <CopyToClipboard
                            text={`${location.origin}/i/${profile?.affiliate_code || ''}`}
                            onCopy={() => {
                              eventTracking('CopyInviteAddress')
                              message.success(translate('invite.link_copied'))
                            }}
                          >
                            <Button type="primary">{translate('invite.copy_invite_link')}</Button>
                          </CopyToClipboard>
                          <img
                            className="img"
                            src={urlSource(`hiflys/point-activity/images/qrcode-mini.webp?v=${Date.now()}`)}
                          />
                          <div className="tip">{translate('invite.scan_qr_code')}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="invite-main" id="publish">
                    <div className="content">
                      <div className="content-header">
                        <div className="title">{translate('invite.publish_content_title')}</div>
                        <div className="desc desc-yellow">
                          <span className="gradient-yellow">{translate('invite.publish_content_subtitle')}</span>
                        </div>
                      </div>
                      <div className="content-main">
                        <div className="recommend">
                          <div className="content-title">{translate('invite.publish_instructions')}</div>
                          <div className="steps">
                            <div className="recommend-content">
                              <div className="title">1、{translate('invite.recommend_content')}</div>
                              <div className="platform">
                                <div className="platform-item">
                                  <a
                                    target="_blank"
                                    href="https://creator.douyin.com/creator-micro/content/upload?enter_from=dou_web"
                                    rel="noreferrer"
                                  >
                                    <img src={Douyin} />
                                  </a>
                                  <div className="text">抖音</div>
                                </div>
                                <div className="platform-item">
                                  <a
                                    target="_blank"
                                    href="https://creator.xiaohongshu.com/publish/publish?source=official"
                                    rel="noreferrer"
                                  >
                                    <img src={Xiaohongshu} />
                                  </a>
                                  <div className="text">小红书</div>
                                </div>
                                <div className="platform-item">
                                  <a
                                    target="_blank"
                                    href="https://cp.kuaishou.com/article/publish/video?origin=www.kuaishou.com"
                                    rel="noreferrer"
                                  >
                                    <img src={Kuaishou} />
                                  </a>
                                  <div className="text">快手</div>
                                </div>
                                <div className="platform-item">
                                  <a
                                    target="_blank"
                                    href="https://channels.weixin.qq.com/platform/post/create"
                                    rel="noreferrer"
                                  >
                                    <img src={Shipinhao} />
                                  </a>
                                  <div className="text">视频号</div>
                                </div>
                                <div className="platform-item">
                                  <a target="_blank" href="https://www.douban.com/" rel="noreferrer">
                                    <img src={Douban} />
                                  </a>
                                  <div className="text">豆瓣</div>
                                </div>
                                <div className="platform-item">
                                  <a target="_blank" href="https://www.zhihu.com/creator" rel="noreferrer">
                                    <img src={Zhihu} />
                                  </a>
                                  <div className="text">知乎</div>
                                </div>
                                <div className="platform-item">
                                  <a target="_blank" href="https://weibo.com/" rel="noreferrer">
                                    <img src={Weibo} />
                                  </a>
                                  <div className="text">微博</div>
                                </div>
                              </div>
                            </div>
                            <div className="recommend-content">
                              <div className="title">2、{translate('invite.submit_verification')}</div>

                              <div className="recommend-content-tip">{translate('invite.publish_to_participate')}</div>
                              <Button type="primary" onClick={submit}>
                                {translate('invite.start_submit')}
                              </Button>
                            </div>

                            <div className="invite-tips">
                              <div className="title">{translate('invite.activity_rules')}</div>
                              <ul>
                                <li>{translate('invite.no_cheating_warning')}</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="invite-header">
                    <div className="invite-info">
                      <div className="info-item">
                        <div className="text">{translate('invite.points_earned')}</div>
                        <div
                          className="num under"
                          onClick={() =>
                            logsRef.current?.scrollIntoView({
                              behavior: 'smooth'
                            })
                          }
                        >
                          {profile?.total_gained_credits || 0}
                        </div>
                      </div>
                      <div className="info-item">
                        <div className="text">{translate('invite.successful_orders')}</div>
                        <div className="num">{profile?.affiliated_membership_order_count || 0}</div>
                      </div>
                      <div className="info-item">
                        <div className="text">{translate('invite.invited_users')}</div>
                        <div className="num">{profile?.affiliated_new_user_count || 0}</div>
                      </div>
                    </div>
                  </div>

                  <div className="invite-table" ref={logsRef}>
                    <div className="table-title">{translate('invite.reward_records')}</div>
                    <Table
                      pagination={
                        logs?.length > 8
                          ? {
                              pageSize: 8,
                              showSizeChanger: false
                            }
                          : false
                      }
                      locale={{
                        emptyText: <div style={{ padding: '40px 0' }}>{translate('invite.no_records')}</div>
                      }}
                      columns={[
                        {
                          title: translate('invite.type'),
                          dataIndex: 'title'
                        },
                        {
                          title: translate('invite.time'),
                          dataIndex: 'create_time',
                          render: (time: number) => <div>{dayjs(time * 1000).format('YYYY-MM-DD HH:mm')}</div>
                        },
                        {
                          title: translate('invite.points'),
                          dataIndex: 'credits'
                        }
                      ]}
                      dataSource={logs}
                    ></Table>
                  </div>
                </div>
              ) : (
                <div className="task-list">
                  {tasks.map((t, index) => (
                    <div className="task-item" key={index}>
                      <div className="item-left">
                        <div className="score">
                          <div className="icon">
                            <IconScore />
                          </div>

                          <span className="gradient">+{t.reward_credits}</span>
                        </div>
                        <div className="desc">{t.description}</div>
                      </div>
                      <div className="item-right">
                        <CheckLogin onLoginSuccess={initData}>
                          {t.category === 1 && t.type === 1 ? (
                            <Button type="primary" disabled={t.status === 2} onClick={receiveAward.bind(this, t.type)}>
                              {t.status === 2 ? translate('invite.signed') : translate('invite.sign')}
                            </Button>
                          ) : (
                            <Button type="primary" disabled={t.status === 2} onClick={toComplete.bind(this, t)}>
                              {t.status === 1 && translate('invite.go_complete')}
                              {t.status === 2 && translate('invite.completed')}
                              {t.status === 3 && translate('invite.receive_award')}
                            </Button>
                          )}
                        </CheckLogin>

                        {t.progress && (
                          <div className="gradient">
                            （{t.progress?.finished || 0}/{t.progress?.total || 0}）
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default memo(Invite)
